<template>
  <div class="box is-radiusless">
    <form @submit.prevent="handleSubmit">
      <div class="field is-horizontal">
        <label for="" class="label field-label">Company Name</label>
        <div class="field-body control">
          <input v-model="name" class="input is-radiusless" type="text">
        </div>
      </div>
      <div class="field is-horizontal">
        <label for="" class="label field-label">Email</label>
        <div class="control field-body">
          <input v-model="email" class="input is-radiusless" type="email">
        </div>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <div class="control"><button type="submit" class="button is-primary is-radiusless">Submit</button></div>
      </div>
    </form>
  </div>
</template>

<script>
import { postNewUser } from '@/utils/api';

export default {
  data() {
    return {
      name: '',
      email: '',
    };
  },
  methods: {
    async handleSubmit() {
      try {
        const status = await postNewUser({ name: this.name, email: this.email });
        console.log(status);
        this.$emit('done');
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
